import storage from 'redux-persist/lib/storage';

import type { PersistConfig } from 'redux-persist';

/** Tokens, session, payroll/plan, and PHI — never in redux-persist (tokens use tab sessionStorage). */
export const SENSITIVE_REDUX_PERSIST_SLICES = [
  'auth',
  'adminSession',
  'userSession',
  'payroll',
  'plan',
] as const;

export type SensitiveReduxPersistSlice = (typeof SENSITIVE_REDUX_PERSIST_SLICES)[number];

/**
 * Non-sensitive onboarding progress + pending post-login deep link
 * (admin email CTA destination) — safe to persist across refresh.
 */
export const PERSIST_WHITELIST = ['flow', 'orgOnboarding', 'postLoginRedirect'] as const;

export type PersistedReduxSlice = (typeof PERSIST_WHITELIST)[number];

export function isSensitiveReduxPersistSlice(sliceKey: string): boolean {
  return (SENSITIVE_REDUX_PERSIST_SLICES as readonly string[]).includes(sliceKey);
}

/** Drops leftover sensitive keys from older persist payloads after whitelist changes. */
export function stripSensitiveSlicesFromPersistedState(state: unknown): unknown {
  if (state == null || typeof state !== 'object') {
    return state;
  }

  const nextState: Record<string, unknown> = { ...(state as Record<string, unknown>) };
  SENSITIVE_REDUX_PERSIST_SLICES.forEach(sliceKey => {
    delete nextState[sliceKey];
  });

  return nextState;
}

export const persistConfig: PersistConfig<unknown> = {
  key: 'spence-root',
  storage,
  version: 2,
  whitelist: [...PERSIST_WHITELIST],
  migrate: state => Promise.resolve(stripSensitiveSlicesFromPersistedState(state)),
};
